<template lang="pug">
    div.main-topic-card-container
        div.columns
            div.column(v-for="topic_card in topic_cards")
                TopicCard(
                    :title="topic_card.title",
                    :image_name="topic_card.image_name",
                    :content="topic_card.content",
                    :has_link_button="topic_card.has_link_button",
                    :button_text="topic_card.button_text",
                    :button_link="topic_card.button_link",
                )
</template>


<script>
import TopicCard from "@/components/TopicCard.vue";

export default {
    components: {
        TopicCard
    },
    props: {
        topic_cards: Array,
    },

}
</script>
